import { FC } from "react";
import { useScrollToHashOnFirstRender } from "shared/utils";

import {
  BandDetails,
  ContactDetails,
  ProfileSummary,
  HelpBlock,
  Documents,
  Preferences,
  ApiKeys,
} from "./containers";

export const ProfilePage: FC = () => {
  useScrollToHashOnFirstRender();

  return (
    <>
      <ProfileSummary showLogout canManageProfile />
      <HelpBlock />
      <ContactDetails canManageProfile />
      <Documents canManageProfile />
      <Preferences canManageProfile />
      <BandDetails />
      <ApiKeys />
    </>
  );
};
